// QuizHeader.tsx
import { memo } from "react";

interface QuizHeaderProps {
  title: string;
  description?: string;
  currentQuestion: number;
  totalQuestions: number;
  primaryColor: string;
}

export const QuizHeader = memo(({ title, description, currentQuestion, totalQuestions, primaryColor }: QuizHeaderProps) => (
  <div className="p-6 border-b bg-gray-50">
    <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
      <div>
        <h1 className="text-3xl font-bold">{title}</h1>
        {description && <p className="text-gray-600 mt-2">{description}</p>}
      </div>
      <div className={`${primaryColor} text-white px-5 py-3 rounded-2xl text-sm font-semibold`}>
        Question {currentQuestion + 1} / {totalQuestions}
      </div>
    </div>
    <div className="w-full h-3 bg-gray-200 rounded-full mt-6 overflow-hidden">
      <div
        className={`h-full ${primaryColor} transition-all duration-300`}
        style={{ width: `${((currentQuestion + 1) / totalQuestions) * 100}%` }}
      />
    </div>
  </div>
));

QuizHeader.displayName = "QuizHeader";